<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.download')" position="top">
                <feather-icon icon="DownloadIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="downloadRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionDelete()">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>
    </div>
</template>

<script>

import {isAPI, isRouter} from "../../../../store/permission"
import {constAPI, constRouter} from "../../../../store/constant"

export default {
    name: 'CellRendererFilesActions',
    data(){
        return {
            employeeId:null,
        }
    },
    created() {
        console.log('id',this.$route.query)
        this.employeeId = this.$route.query.employeeId;
    },
    methods: {
        isPermissionDelete() {
            return isAPI(this, constAPI.employee_edit)
        },
        downloadRecord() {
            window.open(`https://file2.inviv.vn/api/v1/file-entries/download/${this.params.data.metaData.fileEntry.hash}?workspaceId=0`, '_blank')
        },
        confirmDeleteRecord() {
            console.log('ata',this.params)
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá File "${this.params.data.name}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            if (this.params.data.id) {
                this.$vs.loading();
                this.$crm.post(`employee/delete-employee-files?ids=${this.params.data.id}`).then(() => {
                    this.$vs.loading.close();
                    this.showDeleteSuccess();
                    this.$store.commit('DELETE_FILE_EMPLOYEE', this.params.data.id);
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } else {
                this.$store.commit('DELETE_FILE_EMPLOYEE_NOT_ID', this.params.data);
            }
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-check-circle',
            })
        },
        // getUserInfo() {
        //     let employeeId = this.$route.query.id;
        //     console.log(employeeId)
        //     this.$vs.loading();
        //         this.$crm.post('/employee/find-by-id/' + employeeId).then( (response) => {
        //             console.log('res',response)
        //         })
        //         this.$vs.loading.close();
        //     }

    }
}
</script>

<style scoped>

</style>

